export default __webpack_public_path__ + "static/media/5-gm-unachieved_old.0e766c81.svg";